var $4da9b81dea1f6c1b$exports = {};
const $4da9b81dea1f6c1b$var$SCRIPT_URL = "https://script.google.com/macros/s/AKfycbxvdwKki0D-mzQv3tuZeuHkrjbBaFDOQYmtYli8ClflY7qmjSVqBEl2a6RfNMvS7I7e/exec";
document.addEventListener("DOMContentLoaded", function() {
    const subscribeForm = document.getElementById("subscribeForm");
    if (subscribeForm) subscribeForm.addEventListener("submit", $4da9b81dea1f6c1b$var$handleSubscription);
});
async function $4da9b81dea1f6c1b$var$handleSubscription(e) {
    e.preventDefault();
    const emailInput = document.getElementById("emailInput");
    const submitButton = document.getElementById("subscribeBtn");
    if (!submitButton) {
        console.error("Submit button not found");
        return;
    }
    const email = emailInput.value.trim();
    if (!email || !$4da9b81dea1f6c1b$var$isValidEmail(email)) {
        $4da9b81dea1f6c1b$var$setButtonState(submitButton, "error", "Invalid email");
        return;
    }
    emailInput.disabled = true;
    $4da9b81dea1f6c1b$var$setButtonState(submitButton, "loading", "Subscribing...");
    try {
        await fetch($4da9b81dea1f6c1b$var$SCRIPT_URL, {
            method: "POST",
            mode: "no-cors",
            headers: {
                "Content-Type": "text/plain"
            },
            body: JSON.stringify({
                email: email
            })
        });
        emailInput.value = "";
        $4da9b81dea1f6c1b$var$setButtonState(submitButton, "success", "Subscribed!");
    } catch  {
        $4da9b81dea1f6c1b$var$setButtonState(submitButton, "error", "Try again");
    } finally{
        emailInput.disabled = false;
        setTimeout(()=>{
            $4da9b81dea1f6c1b$var$setButtonState(submitButton, "default", submitButton.dataset.originalText);
        }, 3000);
    }
}
function $4da9b81dea1f6c1b$var$setButtonState(button, state, text) {
    if (!button) return;
    if (!button.dataset.originalText) button.dataset.originalText = button.textContent.trim();
    button.classList.remove("btn--loading", "btn--success", "btn--error");
    button.textContent = text;
    button.disabled = state === "loading";
    if (state !== "default") button.classList.add(`btn--${state}`);
}
function $4da9b81dea1f6c1b$var$isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}


//# sourceMappingURL=repo.698bab08.js.map
